import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const Hero = () => {
  return (
    <>
      <section id="hero" className="hero">
        <div className="hero-inner">
          <h1 className="hero-title">
            Global Supply of Premium
            <br />
            Red Chillies &amp; Spices
          </h1>
          <p className="hero-subtitle">
            Trusted import &amp; export partner
            <br />
            delivering consistent quality in bulk.
          </p>
          <div className="hero-actions">
            <button
              type="button"
              className="btn-primary"
              onClick={() =>
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Get Quote
            </button>
            <a
              href="https://wa.me/919652502121"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-whatsapp"
            >
              <FaWhatsapp className="btn-whatsapp-icon" />
              WhatsApp
            </a>
          </div>
        </div>
      </section>
      <div className="hero-stats" aria-label="Company highlights">
        <div className="hero-stat-item">27+ Years Experience</div>
        <div className="hero-stat-item">5000+ Tons Supplied</div>
        <div className="hero-stat-item">1000+ Clients</div>
        <div className="hero-stat-item">Global Export</div>
      </div>
    </>
  );
};

export default Hero;
